export default __webpack_public_path__ + "static/media/1.5bf9df46.jpg";